// extracted by mini-css-extract-plugin
module.exports = {"SectionBanner":"MantrasView_SectionBanner__P9cWG","Wrapper":"MantrasView_Wrapper__8VHIW","Action":"MantrasView_Action__2FiQ_"};